<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Detail.scss";
  .map-container{
    height: 490px;
  }
</style>
<template>
    <div>
        <div class="item-grid-view vx-row match-height mt-4">
            <div class="lg:w-1/3 sm:w-1/2 w-full">
                <div class="w-full grid-view-item">
                    <vx-card class="grid-view-item mb-base overflow-hidden">
                        <gridPrincipalItem
                          img="airflow"
                          :name="response.alias"
                          :description="$t('Labels.Alias')"
                          :name2="response.serie"
                          :description2="$t('Labels.Serie')"
                        ></gridPrincipalItem>
                        <div class="absolute right-0 top-0">
                            <vs-button  @click="deviceStatistics()" class="watersonic edit-button mr-2 mt-2" color="primary" icon="bar_chart" type="border">
                            </vs-button>
                            <vs-button v-if="$store.state.AppActiveUser.userRole === 'MA'" @click="goToConfig()" class="watersonic edit-button mr-2 mt-2" color="grey" icon="icon-settings" icon-pack="feather" type="border">
                            </vs-button>
                        </div>
                        <vs-divider/>
                        <valueItem
                          :description="$t('Labels.Flow')"
                          img="flow" :value="parseFloat(response.flow || 0).toFixed(2)"
                          unit="ft3/h"
                          :min="response.min_flow"
                          :max="response.max_flow"
                        />
                        <valueItem
                          :description="$t('Labels.Temperature')"
                          img="temperature"
                          :value="parseFloat(response.temperature || 0).toFixed(2)"
                          unit="°C"
                          :min="response.min_temperature"
                          :max="response.max_temperature"
                        />
                        <valueItem
                          :description="$t('Labels.Temperature')"
                          img="temperature"
                          :value="celsiusToFahrenheit(response.temperature || 0)"
                          unit="°F"
                          :min="celsiusToFahrenheit(response.min_temperature || 0)"
                          :max="celsiusToFahrenheit(response.max_temperature || 0)"
                        />
                        <valueItem
                          :description="$t('Labels.Pressure')"
                          img="pressure"
                          :value="parseFloat(response.pressure || 0).toFixed(2)"
                          unit="Psi"
                          :min="response.min_pressure"
                          :max="response.max_pressure"
                        />
                        <valueItem
                          :description="$t('Labels.Size')"
                          img="size"
                          :value="response.size"
                          unit="in"
                        />
                        <valueItem :description="$t('Labels.Date')" img="fecha" :value="response.updated_at"></valueItem>
                    </vx-card>
                </div>

            </div>
            <div class="vx-col lg:w-2/3 sm:w-2/3 w-full">
                <vx-card class="grid-view-item mb-base overflow-hidden address-card">
                    <div class="avatar-info-container">
                        <span class="account-number">
                           {{$t("Labels.DeviceLocation")}}
                        </span>
                        <feather-icon
                            icon="EditIcon"
                            @click="editMap = true"
                            class="float-right cursor-pointer"
                            svgClasses="hover:text-primary"
                            v-if="!editMap  && $store.state.AppActiveUser.userRole === 'MA'"/>
                        <feather-icon
                        icon="SaveIcon"
                        @click="saveMap()"
                        class="float-right cursor-pointer"
                        svgClasses="hover:text-primary"
                        v-if="editMap"
                        />
                        <div class="map-container basic-example" v-if="status_mapa">
                            <l-map :center="center" :zoom="zoom" v-if="response">
                                <l-tile-layer :attribution="attribution" :url="url">
                                </l-tile-layer>
                                <l-marker :draggable="editMap" :lat-lng="marker" ref="position_marker">
                                    <l-icon :icon-anchor="staticAnchor">
                                        <img :src="require(`@/assets/images/markers/0.svg`)" width="25px;" alt="ícono marcador"/>
                                    </l-icon>
                                </l-marker>
                            </l-map>
                        </div>
                        <div class="mt-2">
                          <label>{{$t('Labels.References')}}:</label>{{response.location_string  }}
                        </div>
                    </div>
                </vx-card>
            </div>
        </div>
        <div class="item-grid-view vx-row match-height mt-4">
            <div class="w-full">
                <vx-card class="grid-view-item mb-base overflow-hidden">
                    <div class="text-center text-3xl">{{$t("Labels.Alerts")}}</div>
                    <vs-divider/>
                    <div class="container-alerts" v-if="response.min_flow">
                        <minMaxItem
                          :title="$t('Labels.Flow')"
                          :min="response.min_flow"
                          :max="response.max_flow"
                          unit="ft3/h" img="flow_gray"
                          :url="`modelo/airFlow/${response.air_flow_id}`"
                          paramMin="min_flow"
                          paramMax="max_flow"
                          type="PUT"
                          :limitMin="limits.flow.min || 0"
                          :limitMax="limits.flow.max || 0"
                        />
                        <minMaxItem
                          :title="$t('Labels.Temperature')"
                          :min="response.min_temperature"
                          :max="response.max_temperature"
                          unit="°C"
                          img="temperature_gray"
                          :url="`modelo/airFlow/${response.air_flow_id}`"
                          paramMin="min_temperature"
                          paramMax="max_temperature"
                          type="PUT"
                          :limitMin="limits.temperature.min || 0"
                          :limitMax="limits.temperature.max || 0"
                        />
                        <minMaxItem
                          :title="$t('Labels.Pressure')"
                          :min="response.min_pressure"
                          :max="response.max_pressure"
                          unit="Psi"
                          img="pressure_gray"
                          :url="`modelo/airFlow/${response.air_flow_id}`"
                          paramMin="min_pressure"
                          paramMax="max_pressure"
                          type="PUT"
                          :limitMin="limits.pressure.min || 0"
                          :limitMax="limits.pressure.max || 0"
                        />
                    </div>
                </vx-card>
            </div>
        </div>
    </div>
</template>
<script>
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon
} from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import gridPrincipalItem from '@/components/gridPrincipalItem/gridPrincipalItem.vue'
import valueItem from '@/components/valueItem/valueItem.vue'
import minMaxItem from '@/components/minMaxItem/minMaxItem.vue'
import { request } from '@/request.js'
import { celsiusToFahrenheit } from '@/helpers.js'
/* global L:true */

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    minMaxItem,
    valueItem,
    gridPrincipalItem
  },

  data () {
    return {
      zoom: 17,
      center: L.latLng(47.41322, -1.219482),
      url: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png',
      attribution: '',
      marker: L.latLng(47.41322, -1.219482),
      imagePath: 'images/vendor/leaflet/dist/',
      draggable: true,
      staticAnchor: [12, 27],
      response: [],
      icon_marker: [],
      status_mapa: false,
      uuid: this.$route.params.uuid,
      editMap: false,
      limits: {}
    }
  },

  methods: {
    async getResponse () {
      const params = {
        url: `modelo/airFlow/${this.uuid}`,
        method: 'GET'
      }
      await request(params).then(response => {
        this.response = response.data.data
        this.limits = response.data.limits
        const [lat, long] = this.response.location.split(',')
        this.marker = L.latLng(lat, long)
        this.center = L.latLng(lat, long)
        this.status_mapa = true
      })
    },
    async saveMap () {
      const location = this.$refs.position_marker.mapObject.getLatLng()
      const params = {
        url: `modelo/airFlow/${this.uuid}`,
        method: 'PUT',
        params: {
          location: `${location.lat},${location.lng}`
        }
      }
      await request(params).then(() => {
        this.editMap = false
      })
    },
    goToConfig () {
      window.location.href = `/airFlow/config/${this.uuid}`
    },

    deviceStatistics () {
      window.location.href = `/airFlow/statistics/${this.uuid}`
    },
    celsiusToFahrenheit (c) {
      return celsiusToFahrenheit(c)
    }

  },
  sockets: {
    airflow (payload) {
      if (this.uuid === payload.uuid) {
        this.response.pressure = payload.pressure
        this.response.flow = payload.flow
        this.response.temperature = payload.temperature
        this.response.status = payload.status
        this.response.updated_at = payload.updated_at
      }
    }
  },
  created () {
    this.getResponse()
  }
}
</script>
<style scoped="">
    .vue2leaflet-map >>> .leaflet-shadow-pane {
  display: none !important;
}

>>> .vs-input--label {
  padding: 0;
}
</style>
